import type { Auth } from "./auth";

interface AuthHandoffTrackingState {
  current: boolean;
}

export function trackAuthHandoffOnce(
  auth: Pick<Auth, "handoffSource" | "teamId"> | undefined,
  trackingState: AuthHandoffTrackingState,
  logEvent: (
    eventName: string,
    properties: { source: string; team_id: string },
  ) => void,
): void {
  if (!auth?.handoffSource || trackingState.current) {
    return;
  }
  trackingState.current = true;
  logEvent("onboarding_auth_handoff", {
    source: auth.handoffSource,
    team_id: auth.teamId,
  });
}
